<template>
  <NavBar
    :title="htmlname"
  />

</template>

<script>

// @ is an alias to /src
import { NavBar, Image as VanImage, Col, Row, Tag, Cell, CellGroup } from 'vant'
import { fetchList, getaxios, getaxiosdata, deleteaxios, PostData, PostPut, updateArticle } from '@/api/article'

export default {
  name: 'Home',
  components: {
    NavBar

  },
  data() {
    return {
      htmlname: ''
    }
  },
  created() {
    this.htmlname = ''
  },

  methods: {

  }
}
</script>
<style  lang="less" scoped>
    .van-tab__pane{
        width: auto;
        margin: 20px;
        background-color: #fff;
        border-radius: 12px;
        flex-shrink: 0;
        box-sizing: border-box;
    }
    .convey_box{

        background:rgba(245,245,245,1);
    }
    .pdf_box_bg{
        height: 100%;
    }
    .van-doc-demo-block__card{
        margin: 0 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }
    .banner_box{
        position: relative;
        .banner_title_box{
            margin-left: 28px;
            margin-top: 40px;
            position: absolute;
            z-index: 10;
            color: #fff;
            .banner_title{
                font-size: 16px;
                margin-bottom: 16px;
            }
            .case_status{
                margin: 0;
                font-size: 22px;
            }
        }
    }

</style>
